import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const PROJECTS = [
  {
    title: "Meridian Commercial Tower",
    tag: "Commercial",
    year: "2024",
    span: "lg:col-span-8",
    img: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Riverside Civil Works",
    tag: "Civil",
    year: "2023",
    span: "lg:col-span-4",
    img: "https://images.unsplash.com/photo-1536895058696-a69b1c7ba34f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    title: "Hartwell Residence Fit-Out",
    tag: "Interiors",
    year: "2024",
    span: "lg:col-span-4",
    img: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    title: "Eastgate Retail Renovation",
    tag: "Renovation",
    year: "2022",
    span: "lg:col-span-8",
    img: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (i % 2) * 0.1 } }),
};

export const Projects = () => {
  return (
    <section id="projects" className="bg-ink py-24 md:py-36" data-testid="projects">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-flame" />
              <span className="text-xs uppercase tracking-[0.35em] text-secondary-foreground/80">Selected Work</span>
            </div>
            <h2 className="font-heading font-black tracking-tighter text-4xl md:text-6xl leading-[0.95] max-w-2xl">
              Projects that hold <span className="text-flame">their ground.</span>
            </h2>
          </div>
          <span className="font-heading text-secondary-foreground/50 text-lg">04 — Portfolio</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {PROJECTS.map((p, i) => (
            <motion.article
              key={p.title}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              className={`group ${p.span} border border-line overflow-hidden bg-surface`}
              data-testid={`project-card-${i}`}
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={p.img}
                  alt={p.title}
                  className="h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent opacity-60" />
                <span className="absolute top-4 left-4 bg-flame text-ink text-xs font-semibold uppercase tracking-wider px-3 py-1">
                  {p.tag}
                </span>
              </div>
              <div className="flex items-center justify-between p-6">
                <div>
                  <h3 className="font-heading font-bold tracking-tight text-2xl md:text-3xl">{p.title}</h3>
                  <span className="text-secondary-foreground/60 text-sm">{p.year}</span>
                </div>
                <ArrowUpRight className="h-7 w-7 text-secondary-foreground/50 group-hover:text-flame group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-300" />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
